import { render, staticRenderFns } from "./WorkerProfileTempSummary.vue?vue&type=template&id=30c8226b&scoped=true&"
import script from "./WorkerProfileTempSummary.vue?vue&type=script&lang=ts&"
export * from "./WorkerProfileTempSummary.vue?vue&type=script&lang=ts&"
import style0 from "./WorkerProfileTempSummary.vue?vue&type=style&index=0&id=30c8226b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c8226b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol,VContainer,VRow})
